import { z } from "zod";

// Public review page bootstrap (clinic name + optional Google funnel target).
export const reviewInfoSchema = z.object({
	clinic_id: z.string().uuid(),
	name: z.object({ ar: z.string(), en: z.string().optional() }),
	google_review_url: z.string().nullable(),
});
export type ReviewInfo = z.infer<typeof reviewInfoSchema>;

export const submitReviewInputSchema = z.object({
	rating: z.number().int().min(1).max(5),
	comment: z.string().trim().max(2000).optional().or(z.literal("")),
});
export type SubmitReviewInput = z.infer<typeof submitReviewInputSchema>;

// After submit: tell the page whether to surface the Google CTA (happy path).
export const submitReviewResultSchema = z.object({
	ok: z.literal(true),
	google_review_url: z.string().nullable(),
});
export type SubmitReviewResult = z.infer<typeof submitReviewResultSchema>;

// ----- Staff side -----

export const reviewApiSchema = z.object({
	id: z.string().uuid(),
	rating: z.number().int(),
	comment: z.string().nullable(),
	source: z.string(),
	created_at: z.string().datetime(),
});
export type ReviewApi = z.infer<typeof reviewApiSchema>;

export const reviewsSummarySchema = z.object({
	count: z.number().int(),
	average: z.number(), // 0 when no reviews
	distribution: z.object({
		1: z.number().int(),
		2: z.number().int(),
		3: z.number().int(),
		4: z.number().int(),
		5: z.number().int(),
	}),
	google_review_url: z.string().nullable(),
	recent: z.array(reviewApiSchema),
});
export type ReviewsSummary = z.infer<typeof reviewsSummarySchema>;

export const updateGoogleReviewUrlSchema = z.object({
	google_review_url: z.string().url().max(500).nullable().or(z.literal("")),
});
export type UpdateGoogleReviewUrlInput = z.infer<
	typeof updateGoogleReviewUrlSchema
>;
